module.exports = __webpack_public_path__ + "assets/img/7_1429.d9772019.jpg";